export const exactMatchTooltipText = {
  title: 'Exact Match Tool',
  messages: [
    'When checked, this tool will return results that contain the exact keywords or standards codes that you have entered into the search bar',
  ],
};
